var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component"},[_vm._t("default"),_vm._v(" "),(_vm.error)?_c('div',[_c('span',{staticClass:"text-xxs text-red-500",staticStyle:{"padding-left":"10px"}},[_vm._v(_vm._s(_vm.error[0]))])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }